module.exports = __webpack_public_path__ + "img/4f1fc4e.png";